import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { AuthConstants } from '../../modules/auth/contants/auth-constants';
import { ResponseModel } from '../models/response-model';
import { environment } from '../../../environments/environment';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  constructor() {}
/**
 *This methos handle all http request of module auth and check if the request of federated login is true and redirect to
 *the select page
 * @param {HttpRequest<any>} request
 * @param {HttpHandler} next
 * @return {*}  {Observable<HttpEvent<any>>}
 * @memberof LoggingInterceptor
 */
intercept( request: HttpRequest<any>,next: HttpHandler): Observable<HttpEvent<any>> 
  {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => { 
        if(request.url.includes(AuthConstants.FederatedUrlCodePath) )
          {            
            if(event instanceof HttpResponse)
              {
                if(event.body.data!=="")
                  {
                    window.location.href =event.body.data + "&storeId=" + environment.storeId+ "&tenantId="+environment.tenantId+"&userType=External"
                  }                            
              }           
          }
          if(request.url.includes(AuthConstants.FederatedLoginPath) )
            {      
              if(event instanceof HttpResponse)
                {
                  if(event.body.data["access_token"]!=="")
                    {             
                      localStorage.removeItem("token")
                      localStorage.setItem("token",event.body.data["access_token"])
                      localStorage.removeItem("refreshToken")
                      localStorage.setItem("refreshToken",event.body.data["refresh_token"])
                    }                            
                }           
            }
        
      })
    );
  }
}

